export default __webpack_public_path__ + "static/media/boxPumperMb2.bc033de1.png";